import React from 'react';

import type { Filter } from '../../types/SortAndFilter';
import { Flex } from '../Flex';
import { BodyRegularBR1 } from '../Typography';
import FilterOptionsSection from './FilterOptionsSection';
import FilterRangeSection from './FilterRangeSection';
import FilterSearchField from './FilterSearchField';

interface FilterSectionProps {
  filter: Filter;
  filterKey: string;
  searchValues: Record<string, string>;
  filteredOptions: Record<string, any[]>;
  onSearchValueChange: (filterKey: string, value: string) => void;
  onFilterOptionChange: (filterKey: string, optionsKeys: string[]) => void;
  onFilterRangeChange: (filterKey: string, params: any) => void;
  maxItemsVisible?: number;
  rangesWithApplyButton?: boolean;
  hideArticlesCount?: boolean;
  isDrawer?: boolean;
  showSelectAllOption?: boolean;
  searchThreshold?: number;
  placeholder?: string;
}

const FilterSection = ({
  filter,
  filterKey,
  searchValues,
  filteredOptions,
  onSearchValueChange,
  onFilterOptionChange,
  onFilterRangeChange,
  maxItemsVisible,
  rangesWithApplyButton,
  hideArticlesCount,
  isDrawer,
  showSelectAllOption,
  searchThreshold = 15,
  placeholder,
}: FilterSectionProps) => {
  const isGroupAccordion = Boolean(filter.groupKey && filter.name);
  if ('options' in filter) {
    return (
      <>
        {isGroupAccordion && <BodyRegularBR1>{filter.name}</BodyRegularBR1>}
        {filter?.options?.length >= searchThreshold && (
          <Flex>
            <FilterSearchField
              placeholder={placeholder}
              id={`filter-search-${filterKey}`}
              value={searchValues[filterKey] || ''}
              onChange={value => onSearchValueChange(filterKey, value)}
              filterName={filter.name}
            />
          </Flex>
        )}

        <FilterOptionsSection
          filterKey={filterKey}
          multiselect={filter.multiselect}
          showIcon={filter.showIcon}
          options={filteredOptions[filterKey] || filter.options}
          onChange={onFilterOptionChange}
          maxItemsVisible={maxItemsVisible}
          hideArticlesCount={hideArticlesCount}
          isDrawer={isDrawer}
          showSelectAllOption={showSelectAllOption}
        />
      </>
    );
  }

  return (
    <FilterRangeSection
      {...filter}
      key={filter.key}
      withTitle={isGroupAccordion}
      filterKey={filterKey}
      onChange={onFilterRangeChange}
      withApplyButton={rangesWithApplyButton}
    />
  );
};

export default FilterSection;
